import { Component, OnInit } from '@angular/core';
import {RegistrationService} from "@brightside-web/desktop/data-access/onboarding";
import {ActivatedRoute, Router} from "@angular/router";
import {Subscription} from "rxjs";

interface ReferralContentInterface {
  imageName: string,
  titleKey: string,
  textBodyKey: string,
  optionalTextBodyKey: string,
  ctaKey: string,
  secondaryCtaKey: string
}

@Component({
  selector: 'brightside-web-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.scss']
})
export class ReferralComponent {

  sub = new Subscription();

  contentDisplay: ReferralContentInterface;

  referralContent = {
    'assistant' : {
        imageName: 'launch',
        titleKey: 'INVITE_WELCOME_TITLE',
        textBodyKey: 'INVITE_WELCOME_DESC',
        optionalTextBodyKey: 'INVITE_WELCOME_DESC',
        ctaKey: 'LETS_GO',
        secondaryCtaKey: 'IM_NOT_NAME'
      },
    'client' : {
      imageName: 'parachute',
      titleKey: 'REFERRAL_WELCOME_TITLE',
      textBodyKey: 'REFERRAL_WELCOME_DESC',
      optionalTextBodyKey: 'REFERRAL_WELCOME_NAME_DESC',
      ctaKey: 'LETS_GO',
      secondaryCtaKey: ''
    }
  };

  referrerName = '';
  firstName: string;
  referrerType: string;

  constructor(
    private regSvc: RegistrationService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.firstName = this.regSvc.referralItems.firstName ?? '';
    this.referrerType = this.regSvc.referralItems.referrerType ?? '';
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.contentDisplay = this.referralContent[this.referrerType];
    if (this.referrerType === 'client') {
      this.sub.add(
        this.activatedRoute.queryParams.subscribe(
          params => {
            if (params.referrerName) {
              this.referrerName = params.referrerName;
            }
          }
        )
      )
    }
  }

  handleClick(notMe = false) {
    if (notMe) this.regSvc.skipAccountCreation = false;
    this.router.navigate(['/']);
  }
}
